export default "__VITE_ASSET__DgomhuCk__"